// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const BankOtkrytiePure = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="82" height="82" viewBox="0 0 82 82">
    <path
      fill="#FFF"
      fillRule="nonzero"
      d="M40.883 0C18.312 0 .015 18.297.015 40.868s18.297 40.868 40.868 40.868c22.57 0 40.868-18.297 40.868-40.868A40.868 40.868 0 0 0 40.883 0zm-8.61 60.929A3.544 3.544 0 0 1 34 63.242c.213.94.055 1.926-.44 2.753a3.28 3.28 0 0 1-2.928 1.552 4.905 4.905 0 0 1-1.992-.453l-1.918-.908a26.05 26.05 0 0 1-13.515-23.282v-4.1a26.123 26.123 0 0 1 13.545-23.312l1.874-.878a4.759 4.759 0 0 1 1.991-.425 3.324 3.324 0 0 1 2.929 1.567c.496.826.654 1.813.44 2.753a3.544 3.544 0 0 1-1.787 2.357 13.94 13.94 0 0 0-8.054 12.754v14.511a13.984 13.984 0 0 0 8.068 12.798h.059zm36.226-18.01A26.05 26.05 0 0 1 54.984 66.2l-1.918.908a4.832 4.832 0 0 1-1.992.454 3.28 3.28 0 0 1-2.928-1.552 3.807 3.807 0 0 1-.44-2.753 3.529 3.529 0 0 1 1.728-2.313 13.999 13.999 0 0 0 8.083-12.798V33.62a13.955 13.955 0 0 0-8.01-12.769 3.558 3.558 0 0 1-1.786-2.357 3.793 3.793 0 0 1 .44-2.753 3.31 3.31 0 0 1 2.928-1.567 4.7 4.7 0 0 1 1.991.454l1.875.879a26.094 26.094 0 0 1 13.559 23.311v4.1h-.015z"
      opacity=".2"
    />
  </svg>,
);

export const BankOtkrytieIcon: React.SFC<{ iconClassName?: string; style?: React.CSSProperties }> = props => (
  <BankOtkrytiePure className={props.iconClassName} style={props.style} />
);

BankOtkrytieIcon.displayName = 'BankOtkrytieIcon';
